// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/company_lifecycle.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file inventory/v1/company_lifecycle.proto.
 */
export const file_inventory_v1_company_lifecycle: GenFile = /*@__PURE__*/
  fileDesc("CiRpbnZlbnRvcnkvdjEvY29tcGFueV9saWZlY3ljbGUucHJvdG8SDGludmVudG9yeS52MSrhAQoQQ29tcGFueUxpZmVjeWNsZRIhCh1DT01QQU5ZX0xJRkVDWUNMRV9VTlNQRUNJRklFRBAAEiIKHkNPTVBBTllfTElGRUNZQ0xFX1VOU0FOQ1RJT05FRBABEiMKH0NPTVBBTllfTElGRUNZQ0xFX0lOX0VWQUxVQVRJT04QAhIfChtDT01QQU5ZX0xJRkVDWUNMRV9PTkJPQVJERUQQAxIeChpDT01QQU5ZX0xJRkVDWUNMRV9BUkNISVZFRBAEEiAKHENPTVBBTllfTElGRUNZQ0xFX09GRkJPQVJERUQQBUK9AQoQY29tLmludmVudG9yeS52MUIVQ29tcGFueUxpZmVjeWNsZVByb3RvUAFaQWdpdGh1Yi5jb20vbGVtYS5haS9sZW1tYXRhL2FwaS9wcm90by9nZW4vaW52ZW50b3J5L3YxO2ludmVudG9yeXYxogIDSVhYqgIMSW52ZW50b3J5LlYxygIMSW52ZW50b3J5XFYx4gIYSW52ZW50b3J5XFYxXEdQQk1ldGFkYXRh6gINSW52ZW50b3J5OjpWMWIGcHJvdG8z");

/**
 * @generated from enum inventory.v1.CompanyLifecycle
 */
export enum CompanyLifecycle {
  /**
   * @generated from enum value: COMPANY_LIFECYCLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: COMPANY_LIFECYCLE_UNSANCTIONED = 1;
   */
  UNSANCTIONED = 1,

  /**
   * @generated from enum value: COMPANY_LIFECYCLE_IN_EVALUATION = 2;
   */
  IN_EVALUATION = 2,

  /**
   * @generated from enum value: COMPANY_LIFECYCLE_ONBOARDED = 3;
   */
  ONBOARDED = 3,

  /**
   * @generated from enum value: COMPANY_LIFECYCLE_ARCHIVED = 4;
   */
  ARCHIVED = 4,

  /**
   * @generated from enum value: COMPANY_LIFECYCLE_OFFBOARDED = 5;
   */
  OFFBOARDED = 5,
}

/**
 * Describes the enum inventory.v1.CompanyLifecycle.
 */
export const CompanyLifecycleSchema: GenEnum<CompanyLifecycle> = /*@__PURE__*/
  enumDesc(file_inventory_v1_company_lifecycle, 0);

